import { createSlice } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { getSettingAsync, getMetafieldsAsync, deleteMetafieldAsync, updateMetafieldAsync, getFormulaAsync } from './index';

const initialState = {
    isSettingLoading: false,
    isError: false,
    settingData: null,
    isMetafieldsLoading: false,
    metafieldsData: [],
    isDeleteMetafieldLoading: false,
    isUpdateMetafieldLoading: false,
    isFormulaLoading: false,
    formulaData: [],
}

const settingSlice = createSlice({
    name: 'setting',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSettingAsync.pending, (state) => {
                state.isSettingLoading = true;
            })
            .addCase(getSettingAsync.fulfilled, (state, { payload }) => {
                state.isSettingLoading = false;
                state.settingData = payload;
            })
            .addCase(getSettingAsync.rejected, (state) => {
                state.isSettingLoading = false;
                state.isError = false;
                state.settingData = null;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(getMetafieldsAsync.pending, (state) => {
                state.isMetafieldsLoading = true;
            })
            .addCase(getMetafieldsAsync.fulfilled, (state, { payload }) => {
                state.isMetafieldsLoading = false;
                state.metafieldsData = payload;
            })
            .addCase(getMetafieldsAsync.rejected, (state) => {
                state.isMetafieldsLoading = false;
                state.metafieldsData = [];
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
            .addCase(deleteMetafieldAsync.pending, (state) => {
                state.isDeleteMetafieldLoading = true;
            })
            .addCase(deleteMetafieldAsync.fulfilled, (state) => {
                state.isDeleteMetafieldLoading = false;
            })
            .addCase(deleteMetafieldAsync.rejected, (state) => {
                state.isDeleteMetafieldLoading = false;
            })
            .addCase(updateMetafieldAsync.pending, (state) => {
                state.isUpdateMetafieldLoading = true;
            })
            .addCase(updateMetafieldAsync.fulfilled, (state) => {
                state.isUpdateMetafieldLoading = false;
            })
            .addCase(updateMetafieldAsync.rejected, (state) => {
                state.isUpdateMetafieldLoading = false;
            })
            .addCase(getFormulaAsync.pending, (state) => {
                state.isFormulaLoading = true;
            })
            .addCase(getFormulaAsync.fulfilled, (state, { payload }) => {
                state.isFormulaLoading = false;
                state.formulaData = payload;
            })
            .addCase(getFormulaAsync.rejected, (state) => {
                state.isFormulaLoading = false;
                state.formulaData = [];
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
    },
});

export const getAllSetting = (state) => state.setting;

export default settingSlice.reducer;
